import { render, staticRenderFns } from "./om-dynamic-form.vue?vue&type=template&id=3943e3ad"
import script from "./om-dynamic-form.vue?vue&type=script&lang=ts"
export * from "./om-dynamic-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports